import { AbstractBlock } from '../AbstractBlock';
import { ShapeSettings } from '../setting/ShapeSettings';
import { ColorSettings } from '../setting/ColorSettings';
import { CodeSetting } from '../setting/CodeSetting';
import { BlockTypeConsts } from '../setting/BlockTypeConsts';
import { GlobalImport } from '../../utils/GlobalImport';
import { BlockType } from '../../@types/BlockType';
import { block_translation } from '../../lang/BlockTranslation';

const Blockly = GlobalImport.getBlockly();
const t = block_translation;

export class ARFaceSceneSettingAttribute extends AbstractBlock {
  constructor() {
    super(BlockTypeConsts.FACE_AR_SCENE_SETTING_ATTRIBUTE, t.to('顔追跡ARシーン', 'ar_face_scene'));
    this.setNameForCode('mindar-image');
  }

  defineBlock(block: BlockType): void {
    ShapeSettings.setAttributeShape(block);
    ColorSettings.setSceneColor(block);

    block.appendDummyInput().appendField(this.title);
    ShapeSettings.addAttributeOfSceneStartInput(block);
    block.setOutput(true, 'SceneAttribute');
  }

  codeGenerateCore(block: BlockType): string[] {
    const attribute = CodeSetting.getSubAttributeCode(block);

    // a-cameraがなければデフォルトのカメラを設定
    const sceneStr = CodeSetting.getMindArDefaultCameraCode();

    let str = sceneStr;
    str += CodeSetting.getAttributeCode('mindar-face', '');
    str += CodeSetting.getAttributeCode('embedded', '');

    str += CodeSetting.getAttributeCode('color-space', 'sRGB');
    str += CodeSetting.getAttributeCode(
      'renderer',
      'colorManagement: true;physicallyCorrectLights:true;'
    );
    str += CodeSetting.getAttributeCode('vr-mode-ui', 'enabled: false');
    str += CodeSetting.getAttributeCode('device-orientation-permission-ui', 'enabled: false');
    str += attribute;

    return [str];
  }
}
